// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"ae73822f","342":"e4d4ea58"}[chunkId] + ".chunk.js";
};